import { render, staticRenderFns } from "./dept_import_tree.vue?vue&type=template&id=0515f44f&"
import script from "./dept_import_tree.vue?vue&type=script&lang=js&"
export * from "./dept_import_tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports